import { Dock } from '../../../../shared/types/widget';
import { WidgetType } from '../../../../shared/constants/widget';
import WidgetTabGroup from './WidgetTabGroup';
import WidgetRenderer from './WidgetRenderer';
import WidgetLegend from '../../WidgetLegend';
import { motion } from 'motion/react';
import { WIDGET_LOADING_VARIANTS } from '../animations';

type Props = {
  dock: Dock;
  position: number;
};

export default function DockRenderer({ dock, position }: Props) {
  const widgets = dock.widgets.filter(
    (widget) => (widget.type as WidgetType) !== WidgetType.FEEDBACK_BANNER,
  );

  if (!widgets.length) {
    return null;
  }

  const dockHeading = (
    <>
      {dock.title && (
        <div className="mb-4">
          <h3 className="text-black-90 mb-1 text-2xl font-semibold">
            {dock.title}
          </h3>
          <p className="text-black-600 text-xs">{dock.subtitle}</p>
        </div>
      )}
      {dock.meta?.legend && <WidgetLegend legend={dock.meta.legend} />}
    </>
  );

  const dockSpacing = dock.title && position !== 0 ? 'mt-6' : undefined;

  if (dock.meta?.tabView) {
    return (
      <div className={dockSpacing}>
        {dockHeading}
        <WidgetTabGroup
          trackingPageTitle={dock.title || ''}
          widgets={widgets}
        />
      </div>
    );
  }

  return (
    <div className={dockSpacing}>
      {dockHeading}
      <motion.div
        variants={WIDGET_LOADING_VARIANTS}
        initial="hidden"
        animate="visible"
        custom={{
          delayMultiplier: position,
        }}
        className="grid h-fit grid-cols-12 items-stretch gap-6"
      >
        {widgets.map((widget, index) => (
          <WidgetRenderer
            key={widget.id}
            widget={widget}
            delayMultiplier={index + position}
          />
        ))}
      </motion.div>
    </div>
  );
}
